import Hotjar from '@hotjar/browser';

export let hotjarInitialized = false;

export function initHotjar(): void {
  if (hotjarInitialized) {
    return;
  }

  const siteId = import.meta.env.VITE_HOTJAR_SITE_ID;
  const hotjarVersion = import.meta.env.VITE_HOTJAR_VERSION;

  if (!siteId || !hotjarVersion) {
    console.warn('Hotjar configuration missing: VITE_HOTJAR_SITE_ID or VITE_HOTJAR_VERSION not provided');
    return;
  }

  const siteIdNumber = parseInt(siteId);
  const hotjarVersionNumber = parseInt(hotjarVersion);

  Hotjar.init(siteIdNumber, hotjarVersionNumber);
  hotjarInitialized = true;
}
